import Information from "../../../../images/Information.svg";
import LocateAsset from "../../../../images/LocateAsset.svg";

import Input from "../../../../stories/Input/Input";
import { AtsStckItemDetailsEdges } from "../masters/items/queries/types";
interface Props {
  itemDetails: AtsStckItemDetailsEdges[];
}
const ItemDetailsComp = ({ itemDetails }: Props) => {
  return (
    <ul>
      <li>
        <Input id="data_search" placeholder="Search..." />
      </li>
      {itemDetails.map((item, index) => {
        return (
          <li key={index} className="maps__flex--left--asset--sub">
            <div className="maps__flex--left--asset--sub--flex">
              <img src={Information} alt="" />
              <div className="maps__flex--left--asset--sub--block">
                <b>{item.node.prodSerialNo}</b>
                {/* <span>{item.place}</span> */}
              </div>
            </div>

            <img src={LocateAsset} alt="" />
          </li>
        );
      })}
    </ul>
  );
};

export default ItemDetailsComp;
